import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  TextField,
  MenuItem,
  Snackbar,
  Alert,
} from "@mui/material";
import CustomerLayout from "../CustomerLayout";

const TicketSystem = () => {
  const [form, setForm] = useState({
    category: "Shipment Issue",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setSubmitted(true);
    setForm({
      category: "Shipment Issue",
      subject: "",
      message: "",
    });
  };

  return (
    <CustomerLayout>
      <Box sx={{ maxWidth: 980, mx: "auto", py: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            letterSpacing: "-0.02em",
            mb: 1,
          }}
        >
          Submit Ticket
        </Typography>

        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            lineHeight: 1.6,
            mb: 4,
            maxWidth: 820,
          }}
        >
          Submit a support request related to loads, payments, carrier activity, account access, or platform operations.
        </Typography>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            p: { xs: 3, md: 4 },
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              select
              fullWidth
              label="Category"
              name="category"
              value={form.category}
              onChange={handleChange}
              sx={{ mb: 3 }}
            >
              <MenuItem value="Load Issue">Load Issue</MenuItem>
              <MenuItem value="Payment Issue">Payment Issue</MenuItem>
              <MenuItem value="Account Issue">Account Issue</MenuItem>
              <MenuItem value="Driver / Carrier Communication">
                Driver / Carrier Communication
              </MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </TextField>

            <TextField
              fullWidth
              label="Subject"
              name="subject"
              value={form.subject}
              onChange={handleChange}
              sx={{ mb: 3 }}
              required
            />

            <TextField
              fullWidth
              multiline
              rows={5}
              label="Message"
              name="message"
              value={form.message}
              onChange={handleChange}
              sx={{ mb: 3 }}
              required
            />

            <Button
              type="submit"
              variant="contained"
              sx={{
                py: 1.3,
                px: 4,
                textTransform: "none",
                fontWeight: 700,
              }}
            >
              Submit Ticket
            </Button>
          </Box>
        </Paper>

        <Snackbar
          open={submitted}
          autoHideDuration={4000}
          onClose={() => setSubmitted(false)}
        >
          <Alert
            severity="success"
            variant="filled"
            onClose={() => setSubmitted(false)}
          >
            Support ticket submitted.
          </Alert>
        </Snackbar>
      </Box>
    </CustomerLayout>
  );
};

export default TicketSystem;